module.exports = __webpack_public_path__ + "img/lend.0916c5d8.svg";